import { createTheme } from '@mui/material/styles';
import { MuiButton, MuiButtonBase } from './button';
import { palette } from './palette';
import { shadows } from './shadows';
import { MuiTypography, typography } from './typography';
import { MuiCheckbox } from './checkbox';
import { MuiSwitch } from './switch';
import { MuiRadio } from './radio';
import { MuiTab } from './tab';
import { MuiTabs } from './tabs';
import { MuiBadge } from './badge';
import { MuiChip } from './chip';
import { MuiTooltip } from './tooltip';
var theme = createTheme({
    typography: typography,
    palette: palette,
    shadows: shadows,
    components: {
        MuiTypography: MuiTypography,
        MuiButtonBase: MuiButtonBase,
        MuiBadge: MuiBadge,
        MuiButton: MuiButton,
        MuiCheckbox: MuiCheckbox,
        MuiChip: MuiChip,
        MuiSwitch: MuiSwitch,
        MuiRadio: MuiRadio,
        MuiTab: MuiTab,
        MuiTabs: MuiTabs,
        MuiTooltip: MuiTooltip,
    },
});
export { theme };
